import dota2KillIcon from 'app/icons/dota2_kill.svg';
import dota2TowerIcon from 'app/icons/dota2_tower.svg';
import dota2BarrackIcon from 'app/icons/dota2_barrack.svg';
import { formatTimer, mapPropertiesTeams } from 'app/utils/entities/match_data';
import { round } from 'app/utils/number';

const getDota2TeamStatsLines = (data: {
  opponents: OpponentWithTeamStats[];
}): StatLine<StatsDota2>[] => {
  const opponent1Stat = data?.opponents.at(0)?.stats as StatsDota2 | undefined;
  const opponent2Stat = data?.opponents.at(1)?.stats as StatsDota2 | undefined;

  // Sort properties in this array by wanted display order
  const properties: StatProperties<StatsDota2>[] = [
    { name: 'kills', highlighted: 'max', Icon: dota2KillIcon },
    { name: 'towers', highlighted: 'max', Icon: dota2TowerIcon },
    { name: 'barracks', highlighted: 'max', Icon: dota2BarrackIcon },
    { name: 'gold_per_minute', highlighted: 'max', displayFunction: value => `${round(value, 0)}` },
    {
      name: 'first_blood_percentage',
      highlighted: 'max',
      displayFunction: value => `${round(value * 100, 2)}%`
    },
    { name: 'average_game_length', displayFunction: formatTimer }
  ];
  return mapPropertiesTeams(properties, opponent1Stat, opponent2Stat);
};

export { getDota2TeamStatsLines };
